import { types } from '../../types/types';

export const initialState = {
	dates: [],
	myDates: [],
	myDatesPeritaje: [],
	medicines: [],
	documents: [],
	records: [],
	patients: [],
	countries: [],
	active: null,
	alertMedicine: false,
	alertOrder: false,
	alertProcedure: false,
}

export const doctorReducer = (state = initialState, action) => {

	switch (action.type) {

		case types.doctorAddNew:
			return {
				...state,
				doctor: [action.payload, ...state.doctor]
			}

		case types.updateRecord:
			return {
				...state,
				doctor: state.doctor.map(
					doctor => doctor.id === action.payload.id
						? action.payload.doctor
						:
						doctor
				)
			}

		case types.doctorAddMedicine:
			return {
				...state,
				medicines: [action.payload, ...state.medicines]
			}

		case types.doctorReloadAddMedicine:
			return {
				...state,
				medicines: action.payload
			}

		case types.doctorAddMedicineInUpdate:
			return {
				...state,
				medicines: action.payload
			}

		case types.doctorRemoveOneMedicine:
			return {
				...state,
				medicines: state.medicines.filter(medicine => medicine.id !== action.payload)
			}

		case types.doctorActiveAlertMedicine:
			return {
				...state,
				alertMedicine: action.payload
			}

		case types.doctorActiveAlertOrder:
			return {
				...state,
				alertOrder: action.payload
			}

		case types.doctorActiveAlertProcedure:
			return {
				...state,
				alertProcedure: action.payload
			}

		case types.doctorClearMedicines:
			return {
				...state,
				medicines: []
			}

		case types.cleanDoctor:
			return initialState

		case types.doctorUpdateMedicine:
			return {
				...state,
				medicines: state.medicines.map(
					medicines => medicines.id === action.payload.id
						? action.payload.medicines
						:
						medicines
				)
			}

		case types.myDatesLoad:
			return {
				...state,
				myDates: action.payload
			}

		case types.myDatesPeritajeLoad:
			return {
				...state,
				myDatesPeritaje: action.payload
			}

		case types.myRecordsLoad:
			return {
				...state,
				records: action.payload
			}

		case types.myPatientsLoad:
			return {
				...state,
				patients: action.payload
			}

		case types.loadCountriesProf:
			return {
				...state,
				countries: action.payload
			}

		case types.doctorAddDocument:
			return {
				...state,
				documents: [action.payload, ...state.documents]
			}

		case types.doctorRemoveOneDocument:
			return {
				...state,
				documents: state.documents.filter(doc => doc.name !== action.payload)
			}

		case types.doctorClearDocuments:
			return {
				...state,
				documents: []
			}

		case types.doctorActiveHistoryClean:
			return {
				...state,
				records: []
			}

		case types.doctorPatientActive:
			return {
				...state,
				active: {
					...action.payload
				}
			}

		case types.doctorPatientActiveClean:
			return {
				...state,
				active: null
			}

		default:
			return state
	}


}